export function checkDigitAlgorithm(value) {

    if (value.toString().length < 10) {

        return true;
    }

    let checkDigit = value.toString()
        .split('')
        .filter((value, index) => index < 9)
        .map((value, index) => value * (1 + (index + 1) % 2))
        .map(value => value > 9 ? value.toString().split('').reduce((sum, i) => sum + +i, 0) : value)
        .reduce((check, cur) => cur + check, 0)
        .toString();

    checkDigit = +checkDigit.charAt(checkDigit.length - 1);
    if (checkDigit !== 0) {
        checkDigit = 10 - checkDigit;
    }

    return +checkDigit === +value.charAt(9);
}



// WEBPACK FOOTER //
// ./src/app/helpers/check-digit-algorithm.js